import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @Input() whereThis;
  @Input() append;
  @Input() root = 'Ações';
  public data = [];

  constructor() { }

  ngOnInit(): void {
    if (!Array.isArray(this.whereThis)) {
      this.data.push({ title: this.whereThis.title });
    } else {
      this.data = [...this.whereThis];
    }
    if (this.append) {
      this.data.push({ title: this.append })
    }
  }
}
